// @see my.dev.liquidweb.com
import type { AppConfigI } from './example';

const dev: AppConfigI = {
	baseURL: 'https://api-public.newman.dev.liquidweb.com/',
	session: {
		length: 900,
		warningTime: 150,
	},
	hosts: {
		www: 'dev-marketing.liquidweb.com',
		cart: 'cart.newman.dev.liquidweb.com',
		manage: 'manage.newman.dev.liquidweb.com',
		salesforce: 'liquidweb--developer.sandbox.lightning.force.com/lightning/r',
		customer_community: 'liquidweb--developer.sandbox.my.site.com/customer/s',
		managed_apps: 'app.dev.liquidweb.com',
		authorize_net: 'test.authorize.net',
		gator: 'gator.dev.liquidweb.com',
	},
	gaTrackerId: 'G-RWVHZPXV4N',
	gtmContainerId: 'GTM-PQFRHRZH',
	cartStack: {
		siteId: 'k5FaX1lK',
		trackingScriptUrl:
			'https://api.cartstack.com/js/customer-tracking/cart.msmallwood.dev.liquidweb.com:20250_e26c5744de270f74b9fb65dd70ae774c.js',
	},
	guestAuth: {
		__: 'NOT A SECRET — public guest credential, intentionally client-side',
		username: 'remote-signup',
		password: 'r3M0t3s|gnup',
	},
	cart: {
		checkoutURL: 'https://dev-marketing.liquidweb.com/cart/checkout',
		configURL: 'https://dev-marketing.liquidweb.com/configuration',
		cookieDomain: 'liquidweb.com',
		payPalSystem: 'portal_lw',
		payPalSignUpSystem: 'portal_signup_lw',
	},
	chatConfig: {
		enabled: true,
		orgId: '00DWe000002ZeB7',
		deploymentId: 'Liquid_Web_Support_Portal_MIAW',
		communityURL:
			'https://liquidweb--developer.sandbox.my.site.com/ESWLiquidWebSupportPor1740147560083',
		scrt2URL: 'https://liquidweb--developer.sandbox.my.salesforce-scrt.com',
		messagingScriptURL:
			'https://liquidweb--developer.sandbox.my.site.com/ESWLiquidWebSupportPor1740147560083/assets/js/bootstrap.min.js',
		settings: {
			language: 'en_US',
			chatButtonPosition: '32px,32px',
		},
		storageDomain: 'myuat.dev.liquidweb.com',
	},
	openId: {
		client_id: 'lw-portal',
		authority: 'https://login.dev.liquidweb.com',
		accessTokenExpiringNotificationTime: 1200,
	},
	algolia: {
		applicationId: 'PW72AQI7GT',
		searchOnlyApiKey: '68dddee3207e5fc6a1d4b936de592fbd',
	},
	feedback: {
		boardToken: 'e61b5710-cb70-9393-be21-a44ed0dc1f1d',
	},
	googleMapsApiKey__:
		'NOT A SECRET — public Maps/Places browser key, domain-restricted',
	googleMapsApiKey: 'AIzaSyCp1q6YD7Sqz-XNwB8XV5VCetTr-JcQVMc',
	acceptJs: {
		__: 'NOT A SECRET — Authorize.Net Public Client Key, client-side tokenization only',
		src: 'https://jstest.authorize.net/v1/Accept.js',
		merchantKeys: {
			'33hgGT9J':
				'498uAtfY4Y8dRL327GgmvS2jM3LT2Wcx4Eu525hc7LqD7dUCbXtEeSmDpVKjC5DB',
		},
		fallbackMerchant: {
			key: '498uAtfY4Y8dRL327GgmvS2jM3LT2Wcx4Eu525hc7LqD7dUCbXtEeSmDpVKjC5DB',
			id: '33hgGT9J',
		},
		bankMerchant: {
			id: '2vRE3vqf786K',
			key: '9qdChywENMpdVhGy74rYVm7rjGSwt49R4u937Dk93sZu3GvF8kSYT5yT7P4fJb9u',
		},
	},
	stripe: {
		__: 'NOT A SECRET — Stripe publishable key, client-side tokenization only',
		publishableKey:
			'pk_test_51U0MzhEQjUMOPzmHdu7OQTrrofQnLEnlzMIszA5MVZv230HBj7YwL5t4RqtpAfYvm1Zc83RxndC3V2VszW1hn9wE00cN9PIepU',
	},
	theme: 'liquidweb',
	brand: 'liquidweb',
	headsUpDisplay: true,
	methodic: {
		__: 'NOT A SECRET — public `STREAMING_WEB-` channel embed identifier',
		moduleUrl: 'https://widget-nexcess.methodic.ai/client.js',
		apiKey: 'STREAMING_WEB-admin_3230-fbc02afd-c9d7-40d9-8bbc-be917197a36c',
		agentId: '',
		embedType: 'popup',
	},
	featureFlags: {
		scheduledCancellationFlow: false,
	},
};

export default dev;
